<template>
	<div class="step-pre-next">
		<div
			class="pre"
			:class="{ 'hidden': hidePreButton }"
			@click="$emit('preClick')"
		>
			<div class="pre_pic">
				<svg width="50" height="50" viewBox="0 0 50 50">
					<g fill="none" fill-rule="evenodd">
						<path fill="#BF9F5F" d="M50 0H0v50h50z"></path>
						<path
							fill="#FFF"
							fill-rule="nonzero"
							d="M27 19l1.41 1.41L23.83 25l4.58 4.59L27 31l-6-6z"
						></path>
					</g>
				</svg>
			</div>
			<div class="pre_step">上一步</div>
		</div>
		<div
			class="next"
			:class="{ 'hidden': hideNextButton }"
			@click="$emit('nextClick')"
		>
			<div class="next_pic">
				<svg width="50" height="50" viewBox="0 0 50 50">
						<g fill="none" fill-rule="evenodd">
								<path fill="#BF9F5F" d="M0 0h50v50H0z"/>
								<path fill="#FFF" fill-rule="nonzero" d="M23 19l-1.41 1.41L26.17 25l-4.58 4.59L23 31l6-6z"/>
						</g>
				</svg>
			</div>
			<div class="next_step">下一步</div>
		</div>
	</div>
</template>

<script>
export default {
  name: "StepPreNext",
  props: {
    hidePreButton: {
      type: Boolean,
      default: false
    },
    hideNextButton: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang='scss' scoped>
.step-pre-next {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: absolute; // 父層記得加 position: relative
  top: 28vh;
  width: 90%;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 2;
  .pre,
  .next {
    color: $primaryDeepColor;
  }
  svg {
    &:hover path:first-of-type {
      fill: $primaryDeepColor;
      transition: all ease 0.3s;
    }
  }
  .hidden {
    visibility: hidden;
  }
}
</style>
